export default __webpack_public_path__ + "static/media/item-contribution.a70a8370.jpg";